import React from 'react'
import { FormattedMessage } from 'react-intl'

import { ActionMenuDropdownIconWrapper, ActionMenuDropdownMenuItem, ActionMenuDropdownTextWrapper } from '../style'

const ActionDropdownMenu = ({ dropdownItems, closeMenu }) => {

  const renderRows = dropdownItems.map((item) => {
    function handlerClick() {
      item.onClick()
      closeMenu()
    }

    return (
      <ActionMenuDropdownMenuItem
        color={item.color}
        key={item.title}
        disabled={item.disabled}
        isDestructive={item.isDestructive}
        onClick={item.onClick ? handlerClick : ''}
      >
        <ActionMenuDropdownIconWrapper>{item.icon}</ActionMenuDropdownIconWrapper>
        <ActionMenuDropdownTextWrapper>
          <FormattedMessage id={item.title} />
        </ActionMenuDropdownTextWrapper>
      </ActionMenuDropdownMenuItem>
    )
  })

  return <>{renderRows}</>
}

export default ActionDropdownMenu
